import type { RoleName } from '@/types'

/**
 * Rótulos de los roles.
 *
 * Vive en un helper y no repetido en la vista porque el ternario
 * `role === 'admin' ? 'Administrador' : 'Asesor'` solo sirve para dos roles:
 * al añadir el de marketing, todos esos sitios habrían llamado «Asesor» a
 * alguien que no cotiza. Un sitio nuevo que se olvidara de esto habría vuelto
 * a introducir el fallo silenciosamente.
 */

/** Nombre del rol para mostrar. */
export function roleLabel(role: string): string {
  const nombres: Record<RoleName, string> = {
    admin: 'Administrador',
    advisor: 'Asesor',
    marketing: 'Marketing',
  }

  return nombres[role as RoleName] ?? role
}

/**
 * Color de la etiqueta del rol.
 *
 * El marketing va en ámbar a propósito: es el rol que solo mira, y que se
 * distinga en la lista de usuarios evita que alguien le asigne una cotización
 * esperando un comercial.
 */
export function roleSeverity(role: string): 'info' | 'warn' | 'secondary' {
  if (role === 'admin') return 'info'
  if (role === 'marketing') return 'warn'

  return 'secondary'
}
